import { push } from 'connected-react-router'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent from 'agent'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/reports.actions'

function* loadDomainsSaga() {
  try {
    const body = yield call(agent.Domains.all)
    const domains = body.data

    const reports = yield all(domains.map(domain => agent.Reports.get(domain.id)))
    let newDomains = []
    let domain = null
    for (domain in domains) {
      newDomains.push(Object.assign(reports[domain], domains[domain]))
    }
    yield put(actions.loadDomainsSuccess(newDomains))
  } catch (error) {
    yield put(actions.loadDomainsFailure(error))
  }
}

function* loadReportsSaga(params) {
  try {
    const { domainId } = params.payload
    const body = yield call(agent.Reports.get, domainId)
    const reports = body.data.map(report => ({
      ...report,
      attributes: {
        ...report.attributes,
        id: report.id
      }
    }))
    yield put(actions.loadReportsSuccess(domainId, reports))
  } catch (error) {
    yield put(actions.loadReportsFailure(error))
  }
}

function* loadPreviousReportsSaga(params) {
  try {
    const { domainId, reportId } = params.payload
    const body = yield call(agent.Reports.getPrevious, domainId, reportId)
    yield put(actions.loadPreviousReportsSuccess(domainId, reportId, body.data))
  } catch (error) {
    yield put(actions.loadPreviousReportsFailure(error))
  }
}

function* createReportSaga(params) {
  try {
    const { domainId, payload } = params.payload
    const body = yield call(agent.Reports.create, domainId, payload)
    yield put(actions.createReportSuccess(domainId, body.data))

    yield put(push(`/reports/${domainId}`))
  } catch (error) {
    yield put(actions.createReportFailure(error))
  }
}

function* updateReportSaga(params) {
  try {
    const { domainId, reportId, payload } = params.payload
    const body = yield call(agent.Reports.update, domainId, reportId, payload)
    yield put(actions.updateReportSuccess(domainId, reportId, body.data))

    yield put(push(`/reports/${domainId}`))
  } catch (error) {
    yield put(actions.updateReportFailure(error))
  }
}

function* deleteReportSaga(params) {
  try {
    const { domainId, id } = params.payload
    yield call(agent.Reports.del, domainId, id)
    yield put(actions.deleteReportSuccess(domainId, id))
    yield put(push(`/reports/${domainId}`))
  } catch (error) {
    yield put(actions.deleteReportFailure(error))
  }
}

function* deleteReportLogoSaga(params) {
  try {
    const { domainId, id } = params.payload
    yield call(agent.Reports.deleteLogo, domainId, id)
    yield put(actions.deleteReportLogoSuccess(domainId, id))
  } catch (error) {
    yield put(actions.deleteReportLogoFailure(error))
  }
}

function* viewPreviousSaga(params) {
  const { domainId, reportId } = params.payload
  yield put(push(`/reports/${domainId}/report/${reportId}/previous`))
}

function* downloadPreviousSaga(params) {
  const { domainId, reportId, dateFrom, dateTo } = params.payload

  yield call(exportSaga, {
    params: { domainId, reportId, dateFrom, dateTo },
    type: 'report',
    request: agent.Reports.export
  })
}

export default function* accountSagas() {
  yield all([
    takeLatest(actions.loadDomains.type, loadDomainsSaga),
    takeLatest(actions.loadReports.type, loadReportsSaga),
    takeLatest(actions.loadPreviousReports.type, loadPreviousReportsSaga),
    takeLatest(actions.createReport.type, createReportSaga),
    takeLatest(actions.updateReport.type, updateReportSaga),
    takeLatest(actions.deleteReport.type, deleteReportSaga),
    takeLatest(actions.deleteReportLogo.type, deleteReportLogoSaga),
    takeLatest(actions.viewPrevious.type, viewPreviousSaga),
    takeLatest(actions.downloadPrevious.type, downloadPreviousSaga)
  ])
}
